export default __webpack_public_path__ + "static/media/000_intro_part2.vp9.a6dec126.webm";